import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { checkInSchema } from '../schemas/check-in.schema';

/**
 * Validates if a specified action can be performed based on check-in record data validation.
 * @param actualOdometerValue - The actual odometer value to be validated. Must be a number and is required.
 * @param actualCheckInDate - The actual check-in date to be validated. Must be a date, required, and cannot be in the future.
 * @param abortEarly - Specifies whether validation should stop on the first error (default is false).
 * @returns An object containing the validation result:
 *   - isValid: A boolean indicating if the validation passed.
 *   - errors: An array of error messages if validation fails; otherwise, undefined.
 */
export const canPerformAction = (
	actualOdometerValue: number,
	actualCheckInAt: Date,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	const validationResult: ValidationResult = checkInSchema().validate(
		{ actualOdometerValue, actualCheckInAt },
		{
			abortEarly,
		},
	);

	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	return { isValid: true };
};
